import React from 'react';
import className from 'classnames';
import moment from 'moment';
import TableHeader from '../TableHeader';
import axios from 'axios';
import {
  CSRF_TOKEN,
  addNotification,
} from '../../lib/helpers';

import Notification from '../Notification'

const NftList = ({
  nfts
}) => {
  const killPal = (pal_token_id) => {
    if (confirm('Are you sure to KILL this Pal?')) {
      axios.post(`/${gon.currentProvider}/api/pals/${pal_token_id}/kill`, { authenticity_token: CSRF_TOKEN,})
        .then((res) => {
          if (res.status === 200) {
            addNotification({
              message: `Pal ${pal_token_id} killed successfully`,
              type: Notification.NOTIFICATION_TYPES.success,
            })
          }
        })
        .catch((error) => {
          addNotification({
            message: 'Something went wrong',
            type: Notification.NOTIFICATION_TYPES.error,
          })
        })
        .then(() => {
          window.location.reload()
        })
    }
  }

  const revivePal = (pal_token_id) => {
    if (confirm('Are you sure to REVIVE this Pal?')) {
      axios.post(`/${gon.currentProvider}/api/pals/${pal_token_id}/revive`, { authenticity_token: CSRF_TOKEN,})
        .then((res) => {
          if (res.status === 200) {
            addNotification({
              message: `Pal ${pal_token_id} revived successfully`,
              type: Notification.NOTIFICATION_TYPES.success,
            })
          }
        })
        .catch((error) => {
          addNotification({
            message: 'Something went wrong',
            type: Notification.NOTIFICATION_TYPES.error,
          })
        })
        .then(() => {
          window.location.reload()
        })
    }
  }

  return (
    <React.Fragment>
      <div
        className={className('Table', {
          'Table--nfts-list': true
        })}
      >
        {(() => {
          let columnHeaders = [
            {
              label: 'Image'
            },
            {
              label: 'ID'
            },
            {
              label: 'Token id'
            },
            {
              label: 'description'
            },
            {
              label: 'Current earned EMPL'
            },
            {
              label: 'Deposited at'
            },
            {
              label: 'Died At'
            },
            {
              label: 'Actions'
            }
          ]

          return (
            <div className='Table__row'>
              {columnHeaders.map((header, key) => (
                <TableHeader
                  key={key}
                  header={header}
                />
              ))}
            </div>
          )
        })()}

        {nfts.map((nft) => (
          <div
            className='Table__row'
            key={nft.id}
            data-x={nft}
          >
            <div className='Table__col'>
              <img
                src={nft.image}
                width={60}
                height={60}
              />
            </div>
            <div className='Table__col'>{nft.attributes.id}</div>
            <div className='Table__col'>{nft.token_id}</div>
            <div className='Table__col'>{nft.description}</div>
            <div className='Table__col'>{nft.attributes.current_earned_empl}</div>
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: nft.attributes.deposited_at !== null ?
                    moment(nft.attributes.deposited_at * 1000).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div
              className='Table__col'
              dangerouslySetInnerHTML={
                {
                  __html: nft.died_at && nft.died_at !== null ?
                    moment(nft.died_at * 1000).format('YYYY-MM-DD<br />HH:mm')
                  :
                    'N/A'
                }
              }
            />
            <div className='Table__col'>
              { (nft.died_at) &&
                <a className='Button' onClick={() => { revivePal(nft.token_id) }}>Revive</a>
              }

              { (!nft.died_at && nft.attributes.state === 'hatched') &&
                <a className='Button' onClick={() => { killPal(nft.token_id) }}>Kill</a>
              }
            </div>
          </div>
        ))}
      </div>
    </React.Fragment>
  );
}

export default NftList;
